<!-- Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved. -->

<template>
  <div>
    <dialog-comp
      :open="showModal"
      @update:open="(val: boolean) => showModal = val"
    >
      <component
        v-bind="$store.state.info.modal.props"
        :is="$store.state.info.modal.content"
        @close="showModal = false"
      >
      </component>
    </dialog-comp>
    <banner-comp
      v-for="banner in $store.state.info.banners"
      :key="banner.id"
      show
      @close="$store.commit(REMOVE_BANNER, banner.id)"
      :color="banner.color"
      :icon="banner.icon"
    >
      <span>{{ banner.text }}</span>
      <span v-if="banner.links">
        <a
          v-for="link in banner.links"
          :key="link.id"
          @click="link.link"
          href="javascript:void(0)"
          >{{ link.text }}
        </a>
      </span>
    </banner-comp>
    <toast-comp
      :show="$store.state.info.toast.show || false"
      @close="$store.commit(REMOVE_TOAST)"
      :color="$store.state.info.toast.color"
      :icon="$store.state.info.toast.icon"
      :timer="$store.state.info.toast.timer"
    >
      <span>{{ $store.state.info.toast.text }}</span>
      <span v-if="$store.state.info.toast.links">
        <a
          v-for="link in $store.state.info.toast.links"
          :key="link.id"
          @click="link.link"
          href="javascript:void(0)"
          >{{ link.text }}
        </a>
      </span>
    </toast-comp>
  </div>
</template>

<script lang="ts">
import { mutationTypes } from '@/store/info';

export default {
  setup() {
    return {
      ...mutationTypes,
    };
  },
  name: 'notification-comp',
  computed: {
    showModal: {
      get() {
        return !!this.$store.state.info.modal.show;
      },
      set(show: boolean) {
        if (!show) {
          this.$store.commit(mutationTypes.REMOVE_MODAL);
        }
      },
    },
  },
};
</script>
